export default __webpack_public_path__ + "static/media/apparel_disabled.825c4028.jpg";